<template>
  <div class="data-mentor panel panel-default">
    <h2>Learner Support</h2>
    <set-student-metadata
      v-if="selectedProgramme"
      assignedType="coach"
      :mentor="studentCoach"
      :options="coaches"
      :canUpdate="canManageCoaches"
      @new-data="(coachId) => $emit('assign-coach', coachId)"
    ></set-student-metadata>
    <set-student-metadata
      v-if="selectedProgramme"
      assignedType="data mentor"
      :mentor="studentDataMentor"
      :options="dataMentors"
      :canUpdate="canManageMentors"
      @new-data="(mentorId) => $emit('assign-data-mentor', mentorId)"
    ></set-student-metadata>
  </div>
</template>

<style scoped>
.data-mentor {
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;
}

.data-mentor :deep(div > h2) {
  color: var(--kate-type-primary);
  font-size: 1.2em;
}
</style>

<script>
import SetStudentMetadata from './set-student-metadata.vue';

export default {
  components: {
    'set-student-metadata': SetStudentMetadata,
  },

  props: {
    selectedProgramme: Object,
    studentCoach: Object,
    studentDataMentor: Object,
    coaches: Array,
    dataMentors: Array,
  },

  emits: ['assign-coach', 'assign-data-mentor'],

  computed: {
    canManageCoaches() {
      return this.$permissions.hasPermission('manage_coaches');
    },

    canManageMentors() {
      return this.$permissions.hasPermission('manage_mentors');
    },
  },
};
</script>
